export default "__VITE_ASSET__6d092e9d__"